/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  semantic: {
    color: {
      text: {
        default: "#1d1d1d",
        subtle: "#6f6f6f",
        reversed: "#ffffff",
        link: "#004c90",
        disabled: "#878787",
        alert: "#ad0016",
        success: "#006774",
      },
      background: {
        lightest: {
          default: "#ffffff",
        },
        lighter: {
          default: "#f6f6f6",
        },
      },
      feedback: {
        success: {
          default: "#458783",
          text: "#006774",
          hover: "#006774",
          light: "#caded8",
        },
        information: {
          default: "#004c90",
          text: "#004482",
          hover: "#004482",
          light: "#daf0fc",
        },
        neutral: {
          default: "#1d1d1d",
          text: "#1d1d1d",
          hover: "#3f3f3f",
          light: "#f6f6f6",
        },
        "heads-up": {
          default: "#803308",
          text: "#5f290d",
          hover: "#5f290d",
          light: "#ffe6ab",
        },
        alert: {
          default: "#ad0016",
          text: "#88292d",
          hover: "#7e0010",
          light: "#f2d0cf",
        },
      },
      interaction: {
        "level 1": "#ffffff",
        "level 2": "#f6f6f6",
        active: "#ededed",
        hover: "#daf0fc",
        error: "#f2d0cf",
        inactive: {
          "level 1": "#f6f6f6",
          "level 2": "#dadada",
          "level 3": "#9d9d9d",
          "level 4": "#878787",
        },
        conversion: {
          default: "#004c90",
          hover: "#004482",
          light: "#c8e8fa",
        },
      },
      border: {
        brand: {
          "level 1": "#94c9e2",
          "level 2": "#004c90",
          "level 3": "#00396c",
        },
        primary: {
          "level 1": "#dadada",
          "level 2": "#c6c6c6",
          "level 3": "#878787",
          "level 4": "#000000",
        },
        alert: {
          "level 1": "#ad0016",
        },
      },
      decroative: {
        main: {
          "level 1": "#f6f6f6",
          "level 2": "#ededed",
          "level 3": "#e4e4e4",
          "level 4": "#dadada",
          "level 5": "#c6c6c6",
        },
        brand: {
          "x light": "#daf0fc",
          light: "#c8e8fa",
          dark: "#002d56",
          "x dark": "#00192f",
        },
      },
      brand: {
        primary: {
          blue: "#004c90",
        },
        accent: {
          salmon: "#f8bb9f",
          amaranth: "#ed585d",
          amber: "#ffd455",
          "jade green": "#6ab3a9",
          "sky blue": "#94c9e2",
        },
        light: {
          "baby pink": "#f2d0cf",
          "baby yellow": "#ffe6ab",
          "baby green": "#caded8",
          "baby blue": "#c8e8fa",
          sand: "#f9e6d8",
        },
        dark: {
          "dark blue": "#00396c",
          burgundy: "#ad0016",
          "dark orange": "#ffa336",
          "petroleum green": "#006774",
          "dark brown": "#955d3f",
        },
      },
    },
  },
};
